import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import SubTab from "./../SubTab/SubTab";

const YouthJobIncentive = () => {
  const category = "YouthJobIncentive";
  const [dotCount, setDotCount] = useState(0);
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  // 점 애니메이션 (... 깜빡이는 효과)
  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const movePage = (path) => {
    navigate(path);
  };

  const containerStyle = {
    width: "100%",
    height: "60vh", // 🔹 세로 크기 줄임
    background: "#f8f8f8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    fontFamily: "'Pretendard', 'Noto Sans KR', sans-serif",
    color: "#202632",
    textAlign: "center",
  };

  const logoStyle = {
    fontSize: "26px",
    fontWeight: "700",
    color: "#00a45a", // 🔹 포인트 녹색
    letterSpacing: "1px",
    marginBottom: "10px",
  };

  const titleStyle = {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "10px",
  };

  const subStyle = {
    fontSize: "16px",
    color: "#555",
    marginBottom: "15px",
  };

  const dotWrapperStyle = {
    height: "30px", // 🔹 높이 고정 → 점 위치 고정
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    color: "#00a45a",
    fontWeight: "700",
    letterSpacing: "3px",
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {"> "}사업분야{" > "}기업 지원 사업
            </div>
            <div className="banner_main_text">기업 지원 사업</div>
          </div>
        </div>
        <div className="navi_area">
          <div className="navi_back">
            <div
              className="navi_box business_field"
              onClick={() => handleSelect(1)}
            >
              <div className="navi_main_text">기업지원사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && "active"}`}>
                <div
                  className="select_row"
                  onClick={() => movePage("/fusionSupportProgram")}
                >
                  산학융합지구조성사업
                </div>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/chungnamInnovationProject")
                  }
                >
                  기업지원사업
                </div>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/localIndustryTalentDevelopment")
                  }
                >
                  인재양성사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/dangjinStartupSupport")}
                >
                  창업육성사업
                </div>
              </div>
            </div>
            <div
              className="navi_box enterprise"
              onClick={() => handleSelect(2)}
            >
              <div className="navi_main_text">
                청년일자리 도약장려금지원 사업
              </div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && "active"}`}>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/chungnamInnovationProject")
                  }
                >
                  충남지역혁신프로젝트 사업
                </div>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/chungnamInnovationCluster")
                  }
                >
                  충남지역혁신클러스터
                </div>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/carbonNeutralInfrastructure")
                  }
                >
                  탄소중립실증인프라구축사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/EnergyGrowthSupport")}
                >
                  에너지 동반성장 상생혁력지원 사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/LocalYouthJob")}
                >
                  충남 지역주도형 청년일자리지원 사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/YouthJobIncentive")}
                >
                  청년일자리 도약장려금지원사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/SMECenterSupport")}
                >
                  중소기업지원센터지원 사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/DormLeaseSupport")}
                >
                  산업단지 기숙사 임차지원 사업
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sub_main_area temporary">
          <SubTab category={category} />
          {/* 🔹 공통으로 돌려 쓸 카드 헤더(리디자인 영역) */}
          <div className="business-hero">
            <div className="business-hero-inner">
              <p className="business-hero-tag">Youth Job Incentive Program</p>
              <h2 className="business-hero-title">
                청년일자리 도약장려금 사업
              </h2>
              <p className="business-hero-period">
                사업기간 : 2025. 1. 1. 〜 2025. 12. 31.
              </p>
            </div>
          </div>
          <div className="sub_main_back">
            <div className="business_title"></div>
            <div className="vision_container">
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업내용</div>
              </div>
              <div className="business_img_box">
                <div className="youth-job-incentive-img1"></div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">추진체계</div>
              </div>
              <div className="propulsion_img_box">
                <div className="youth-job-incentive-img2"></div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업목표</div>
              </div>
              <div className="objective_box">
                <p className="objective_title first">
                  취업애로청년에게 양질의 일자리를 제공하여 사회 ‧ 경제적 자립을
                  돕고 청년 실업률을 감소하고 청년층의 안정적인 정규직 취업을
                  촉진하고, 기업의 청년 채용 부담을 완화하여 고용을 확대하도록
                  지원
                </p>
              </div>
              <div className="vision_title_box">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">최종 목표</div>
              </div>
              <div className="objective_box">
                <p className="local_final_result_item">
                  ❍ 중소‧중견기업이 청년 채용 부담을 경감하여 청년 고용 확대를
                  유도
                </p>
                <p className="local_final_result_item">
                  ❍ 지원금을 통한 기업의 인건비 부담 완화로 신규 채용 여력이
                  증가하여 청년 채용률 상승
                </p>
                <p className="local_final_result_item">
                  ❍ 취업애로계층에 대한 채용 지원을 강화하여 경제적 어려움을
                  겪는 청년층의 사회‧경제적 자립 기회 확대
                </p>
                <p className="local_final_result_item">
                  ❍ 청년들이 단순 단기 계약직이 아닌 정규직으로 채용될 수 있도록
                  유도하여 고용 안정성 강화
                </p>
                <p className="local_final_result_item">
                  ❍ 일정 기간 이상 근속한 청년에게 장기근속 인센티브를 제공하여
                  지속적인 경제적 자립 가능성 확대
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YouthJobIncentive;
